import Vue from 'vue';

const success = (context, data) => {
  $('.cancel').removeClass('disabled');
  $('.confirm').removeClass('disabled');
  const message = `Subscription ${data.pause_subscription ? 'paused' : 'resumed'} successfully`;
  swal('Done!', message, 'success');
  context.fetch_users();
};

const failed = (error) => {
  $('.cancel').removeClass('disabled');
  $('.confirm').removeClass('disabled');
  swal('Error!', error.response.data.msg, 'warning');
};


export default (context, user, data) => Vue.$http.put(`/users/${user.id}/pause-subscription`, data).then((response) => {
  if (response && response.status === 200) {
    success(context, data);
  }
}).catch((error) => {
  failed(error);
});



// WEBPACK FOOTER //
// ./src/app/services/admin/pauseSubscription.js